import { IRegistrationSection } from '../../../interfaces/scheduler_interfaces';
import { IDefineCommand, IQuery } from 'core-ts-types';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { IRegisterSectionsDatasource } from '../../../views/course_scheduler/datasources/register_sections_datasource';
import { TermCourseServant } from '../../../views/term_courses/servants/term_course_servant';
import { UpdateSectionSelectionCommand } from './update_section_selection_command';

export type UpdateSelectedSectionStatusCommand = (section: ISection, isSelected: boolean) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'updateSelectedSectionStatusCommand',
    function updateSelectedSectionStatusCommand(
      defineCommandORM: IDefineCommand,
      $q: ng.IQService,
      ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
      updateSectionSelectionsCommand: UpdateSectionSelectionCommand
    ) {
      'use strict';

      return defineCommandORM(
        'updateSelectedSectionStatusCommand',
        (deferred, section: ISection, isSelected: boolean) => {
          const updatedRegistrationSections = _4.map(
            ngRegisterSectionsDatasource.values(),
            (registrationSection: IRegistrationSection) => {
              const isMultiSection = TermCourseServant.isMultiSectionCourse(section._course);
              // if multi-section we update the selection status for all IRegistrationSections of the same course
              // if not multi-section we only update the section with the matching id
              const comparisonCriteria = (
                sectionA: IRegistrationSection,
                sectionB: ISection,
                isMultSection: boolean
              ): boolean =>
                isMultSection
                  ? _4.isEqual(sectionA.course, sectionB.course) &&
                    _4.isEqual(sectionA._section_type.session, sectionB._section_type.session)
                  : _4.isEqual(sectionA.id, sectionB.id);

              return comparisonCriteria(registrationSection, section, isMultiSection)
                ? { ...registrationSection, is_selected: isSelected }
                : registrationSection;
            }
          );
          ngRegisterSectionsDatasource.write(updatedRegistrationSections);
          const updateSectionSelectionPromises = updatedRegistrationSections.map((section) =>
            updateSectionSelectionsCommand(section.id, section.is_selected)
          );
          $q.all(updateSectionSelectionPromises).then(deferred.resolve);
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_selections/commands/update_selected_section_status_command.ts